module.exports = __webpack_public_path__ + "img/f3.11a0defe.png";